import { trackError } from 'helpers/track_error';
import type { CompanyLead } from 'packages/signup/components/signupForm/types';
import { localStorageSetItem } from 'entrypoints/storage_helpers';
import trackFormSubmissionForPixel from 'packages/signup/analytics/trackFormSubmission';

export const trackCompanyLeadFormError = ({
  submittedFrom,
  responseText,
  status,
}: {
  status: string;
  responseText: string;
  submittedFrom: string;
}) => {
  trackError({
    error: new Error(`${submittedFrom} Failed with status: ${status}`),
    custom: {
      message: responseText,
    },
  });
};

export const trackCompanyLeadFormSubmitted = ({
  submittedFrom,
  values,
}: {
  submittedFrom: string;
  values: CompanyLead;
}) => {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'CompanyLeadFormSubmitted',
    data: {
      number_employees: values?.number_employees,
      industry: values?.industry,
      submitted_from: values?.submitted_from || submittedFrom,
      identifier: submittedFrom,
    },
  });
  localStorageSetItem('filledLeadForm', 'true');
};

export const trackLeadFormSubmissionForPixel = trackFormSubmissionForPixel;
